<ngx-loading-bar #loading color="#3AA36B" includeSpinner="false" height="3px"></ngx-loading-bar>

<div id="service-order-return">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="serviceOrder">
      <div class="row">
        <div class="col">
          <label>
            <span>*DESCREVA O MOTIVO DO RETORNO</span>
            <textarea formControlName="dsObservacao"></textarea>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <button [disabled]="serviceOrder.invalid" (click)="returnServiceOrder();">RETORNAR PARA LOJA</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
